var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3327 22.1668C13.6021 22.1668 14.8591 21.9168 16.032 21.431C17.2048 20.9452 18.2704 20.2332 19.168 19.3355C20.0657 18.4379 20.7777 17.3723 21.2635 16.1994C21.7493 15.0266 21.9993 13.7696 21.9993 12.5002C21.9993 11.2307 21.7493 9.9737 21.2635 8.80089C20.7777 7.62808 20.0657 6.56243 19.168 5.6648C18.2704 4.76716 17.2048 4.05512 16.032 3.56933C14.8591 3.08353 13.6021 2.8335 12.3327 2.8335C9.76892 2.8335 7.31017 3.85195 5.49732 5.6648C3.68447 7.47765 2.66602 9.9364 2.66602 12.5002C2.66602 15.0639 3.68447 17.5227 5.49732 19.3355C7.31017 21.1484 9.76892 22.1668 12.3327 22.1668ZM11.0255 8.19313L17.0876 11.5614C17.255 11.6545 17.3944 11.7906 17.4915 11.9556C17.5886 12.1207 17.6398 12.3087 17.6398 12.5002C17.6398 12.6916 17.5886 12.8797 17.4915 13.0447C17.3944 13.2098 17.255 13.3459 17.0876 13.4389L11.0255 16.8072C10.8292 16.9163 10.6079 16.9722 10.3833 16.9694C10.1587 16.9666 9.93882 16.9052 9.74531 16.7913C9.5518 16.6773 9.39142 16.5148 9.28007 16.3197C9.16871 16.1247 9.11025 15.904 9.11046 15.6794V9.3209C9.11025 9.09633 9.16871 8.8756 9.28007 8.68058C9.39142 8.48556 9.5518 8.32302 9.74531 8.20906C9.93882 8.09511 10.1587 8.03369 10.3833 8.03089C10.6079 8.0281 10.8292 8.08402 11.0255 8.19313Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.f9dd39dbf42224cd41684dacca5a2f02.svg";
export { ForwardRef as ReactComponent };